<template>


    <div>
        <v-layout row justify-center>
        </v-layout>
        <v-layout row wrap>
            <v-toolbar size="120px" dark color="info">
                <v-toolbar-title class="baslikfont">Cari Kartlar</v-toolbar-title>
                <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search" label=" Ara"
                                append-icon="search"></v-text-field>
            </v-toolbar>
        </v-layout>
        <v-card>

            <v-data-table :headers="headers" :loading="progress" :rows-per-page-items=[50,100] :items="items" :search="search"
                id="datatable">
                <v-progress-linear slot="progress"  indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr @click="git(props.item.Kod)" item>
                        <td class="text-xs-left">{{ props.item.Kod }}</td>
                        <td class="text-xs-left">{{ props.item.Unvan }}</td>
                        <td class="text-xs-left">{{ props.item.Tel1 }}</td>
                        <td class="text-xs-left">{{ props.item.Adres }}</td>
                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Aradığınız "{{ search }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                </v-alert>
            </v-data-table>
        </v-card>

        <template>
            <v-card>
                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                    :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text }}
                    <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
            </v-card>
        </template>
    </div>
</template>


<script>
    import auth from '../../../api/auth'

    export default {
        data() {
            return {
                headers: [{
                        text: 'Cari Kodu',
                        value: 'Kod'
                    },
                    {
                        text: 'Ünvan ',
                        value: 'Unvan'
                    },
                    {
                        text: 'Telefon1',
                        value: 'Tel1'
                    },
                    {
                        text: 'Adres',
                        value: 'Adres'
                    }
                ],
                Current: {
                    Kod: '',
                    Unvan: '',
                    Tel1: '',
                    Phone2: '',
                    Mobile: '',
                    Web: '',
                    Authorized: '',
                    WarningNote: '',
                    InfoNote: '',
                    Invoice: {
                        Adres: '',
                        PostCode: '',
                        Province: '',
                        Country: '',
                        TaxNumber: '',
                        TaxOffice: '',
                        IdentityNumber: ''
                    }
                },
                items: [],
                selected: '',
                m: false,
                k: false,
                dialog: false,
                dialog_baslik: '',
                codegorunum: true,
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                text: '',
                search: '',
                loading: true,
                progress: true
            }
        },
        methods: {
            git: git
        },
        beforeMount: beforeMount,
    }

    function git(v) {
        var url = "#/cari/goster/" + v
        window.open(url, '_target')
    }

    function beforeMount() {
        this.progress = true

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
            CompanyCode: credentials.SirketKodu,
            Code: null
        }
        this.$http.post(auth.API_URL + 'api/Current/List', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            this.items = response.body
            this.progress = false

        }, (response) => {
            if (response.status === 0) {
                this.progress = false

            } else {
                this.progress = false

            }
        })
    }
</script>

<style>
</style>